import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Wlasne ikony akcji dokumentowych (proforma / faktura VAT / korekta).
 *
 * Dlaczego nie zwykle <mat-icon>nazwa</mat-icon>:
 *  - glify Materiala byly mylace w tym panelu — „faktura VAT" dostawala ikone
 *    PARAGONU (receipt_long), a paragon to tutaj osobna akcja; korekta miala
 *    ikone „edytuj dokument", co nie mowi nic o korygowaniu,
 *  - stare zakladki PrimeNG maja te akcje jako <img src="assets/svg/*.svg">
 *    i skorki podmieniaja im ksztalty CSS-em. Dla <mat-icon> to niemozliwe,
 *    bo ikona jest identyfikowana TRESCIA TEKSTOWA, ktorej CSS nie widzi.
 *    Rejestracja wlasnych SVG to jedyny sposob, zeby oba komplety zakladek
 *    pokazywaly ten sam ksztalt.
 *
 * Ikony uzywaja stroke="currentColor", wiec dziedzicza kolor ze skorki.
 */
@Injectable({ providedIn: 'root' })
export class AppIconsService {
  private static readonly IKONY: ReadonlyArray<[string, string]> = [
    ['doc-proforma', 'assets/svg/doc-proforma.svg'],
    ['doc-vat', 'assets/svg/doc-vat.svg'],
    ['doc-correction', 'assets/svg/doc-correction.svg'],
  ];

  constructor(
    private registry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  register(): void {
    AppIconsService.IKONY.forEach(([nazwa, sciezka]) => {
      this.registry.addSvgIcon(
        nazwa,
        this.sanitizer.bypassSecurityTrustResourceUrl(sciezka),
      );
    });
  }
}
